import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=4353b18d&"
import script from "./addForm.vue?vue&type=script&lang=ts&"
export * from "./addForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports